module.exports = __webpack_public_path__ + "static/img/salepage-stk-payment_04.1163cb8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salepage/banner/payment/salepage-stk-payment_04.webp
// module id = zGfj
// module chunks = 134